<template>
  <id-pswd-wrtg v-if="step == 1"
                :tab-se="'id'"
                @next="comptIdWrtg"
                @close="emits('close')"/>
  <id-compt v-if="step == 2"
            :mber-nm="mberNm"
            :mber-ids="mberIds"
            @chng-tab="emits('chng-tab')"
            @close="emits('close')"/>
</template>

<script setup>
import IdPswdWrtg from "@/views/lgin/id-pswd-wrtg.vue";
import IdCompt from "@/views/lgin/id-compt.vue";

import {ref, defineEmits} from "vue";

import {getUtils, getStore} from "@/utils/import";
const {$axios, $alert, $cmmn} = getUtils();
const {$loading} = getStore();

const emits = defineEmits(['chng-tab', 'close']);
const step = ref(1);

const mberNm = ref('');
const mberIds = ref([]);
const comptIdWrtg = async ({mberNm: wrtgMberNm, mbpnTlno}) => {
  try {
    $loading.on();

    const {data} = await $axios.get('/api/mber/ids/by-mber-nm-mbpn-tlno', {params : {mberNm: wrtgMberNm, mbpnTlno}});
    if (!data.length) {
      $alert('입력한 정보와 일치하는 회원이 없습니다.<br/>정확한 정보를 입력해주세요.');
      return false;
    }

    mberNm.value = wrtgMberNm;
    mberIds.value = data;
    step.value += 1;
  } catch (e) {
    await $cmmn.errorMsg(e);
  } finally {
    $loading.off();
  }
}

</script>

<style scoped>

</style>
